import React, { useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
const PORTAL_IMAGE = 'https://cdn.magicpatterns.com/uploads/uhLrwtrZAkjAonsADz8Jfe/ChatGPT_Image_27_may_2026,_15_23_37.png';
const COMPLETE_EXPERIENCE_IMAGE = 'https://cdn.magicpatterns.com/uploads/5yrQLTQ4vG3TPBLs1DkjKn/Kit_Terapeutico_y_Tarot_Completo.webp';
const PORTAL_CHECKOUT = 'https://codex-labs.shop/cart/43552261701691:1';
const COMPLETE_EXPERIENCE_CHECKOUT = 'https://www.codex-labs.shop/cart/44528114892859:1';
const INDIVIDUAL_CHECKOUT = 'https://codex-labs.shop/cart/43433734733883:1';
const BASE_OFFER = {
  regular: 79960,
  final: 39990
};
const COMPLETE_OFFER = {
  regular: 99990,
  final: 49980
};
function formatPrice(price: number) {
  return price.toLocaleString('es-AR');
}
export function PortalOffer() {
  const [includesInterpretation, setIncludesInterpretation] = useState(false);
  const prefersReducedMotion = useReducedMotion();
  const offer = includesInterpretation ? COMPLETE_OFFER : BASE_OFFER;
  const savings = offer.regular - offer.final;
  const discount = Math.round((1 - offer.final / offer.regular) * 100);
  const goToCheckout = () => {
    window.location.href = includesInterpretation ? COMPLETE_EXPERIENCE_CHECKOUT : PORTAL_CHECKOUT;
  };
  return <section className="w-full overflow-hidden bg-[#fdfbf7] py-16 md:py-24" data-id="element-242" data-mp="1iv6ckzqcb23w">
      <div className="mx-auto max-w-xl px-4" data-id="element-243" data-mp="26liqqsc6hv2x">
        <motion.div initial={prefersReducedMotion ? undefined : {
        opacity: 0,
        y: 16
      }} whileInView={prefersReducedMotion ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.4,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center" data-id="element-244" data-mp="26ioaze440yfu">
          <p className="text-[10px] font-black uppercase tracking-[0.22em] text-[#a8894f] md:text-xs" data-id="element-245" data-mp="m4e4ao9neeco">
            Oferta de expansión
          </p>
          <h2 className="mt-3 font-['Playfair_Display',_serif] text-3xl font-bold leading-tight text-[#2e1065] md:text-5xl" data-id="element-246" data-mp="q44t4mfm6kek">
            ¿Y si mañana querés sumar otra terapia?
          </h2>
          <p className="mx-auto mt-3 max-w-[37ch] text-sm leading-relaxed text-[#665873] md:text-base" data-id="element-247" data-mp="2nvwhtt1qvsqi">
            No hace falta comprar cada material por separado. Podés llevarte los
            4 kits juntos y ahorrar casi $40.000.
          </p>
        </motion.div>

        <motion.div initial={prefersReducedMotion ? undefined : {
        opacity: 0,
        y: 16
      }} whileInView={prefersReducedMotion ? undefined : {
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.45,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-7" data-id="element-248" data-mp="2a36iyo14atbz">
          <motion.img key={includesInterpretation ? 'complete-experience' : 'portal'} initial={prefersReducedMotion ? undefined : {
          opacity: 0,
          scale: 0.97
        }} animate={prefersReducedMotion ? undefined : {
          opacity: 1,
          scale: 1
        }} transition={{
          duration: prefersReducedMotion ? 0 : 0.35,
          ease: [0.23, 1, 0.32, 1]
        }} src={includesInterpretation ? COMPLETE_EXPERIENCE_IMAGE : PORTAL_IMAGE} alt={includesInterpretation ? 'Combo Portal Terapéutico con Pack Interpretación Completa' : 'Pack Portal Terapéutico Completo con cuatro sistemas'} className="block h-auto w-full object-contain" data-id="element-249" data-mp="1v78snmdvkj7o" />
        </motion.div>

        <motion.div layout transition={{
        duration: prefersReducedMotion ? 0 : 0.35,
        ease: [0.23, 1, 0.32, 1]
      }} className={`relative mt-6 overflow-hidden rounded-3xl border p-5 transition-[background-color,border-color,box-shadow] duration-500 ease-out ${includesInterpretation ? 'border-[#e2bd65] bg-[#241047] shadow-[0_20px_44px_-20px_rgba(46,16,101,0.95)]' : 'border-[#d7ae4d] bg-white shadow-[0_16px_30px_-26px_rgba(46,16,101,0.65)]'}`} data-id="element-250" data-mp="3f3ejrxfphzfl">
          {includesInterpretation && <>
              <span aria-hidden="true" className="pointer-events-none absolute left-4 top-9 h-1.5 w-1.5 rounded-full bg-[#e2bd65] shadow-[0_0_12px_4px_rgba(226,189,101,0.7)]" data-id="element-251" data-mp="2h82fmgwzc59a" />
              <span aria-hidden="true" className="pointer-events-none absolute right-8 top-16 h-1 w-1 rounded-full bg-[#f0d584] shadow-[0_0_10px_3px_rgba(240,213,132,0.75)]" data-id="element-252" data-mp="2q9a09w6kp7kw" />
            </>}
          {includesInterpretation && <motion.div initial={prefersReducedMotion ? undefined : {
          opacity: 0,
          y: 8
        }} animate={prefersReducedMotion ? undefined : {
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} className="mb-4 text-center" data-id="element-253" data-mp="304brqyobmlqn">
              <span className="inline-flex items-center gap-1 rounded-full bg-[#e2bd65] px-3 py-1 text-[10px] font-black uppercase tracking-[0.12em] text-[#2e1065]" data-id="element-254" data-mp="3iwwfy2t2s2o4">
                <SparklesIcon size={12} aria-hidden="true" data-id="element-255" data-mp="3dvynmxecps8w" /> Experiencia más completa
              </span>
              <p className="mt-3 text-sm font-bold text-white" data-id="element-256" data-mp="1ce2p8rq4on7">
                ¡Desbloqueaste el pack más completo!
              </p>
            </motion.div>}

          <label className={`flex cursor-pointer items-start gap-3 rounded-2xl border p-4 transition-colors duration-200 ease-out ${includesInterpretation ? 'border-[#e2bd65]/70 bg-white/10 text-white' : 'border-[#e7dbcb] bg-[#fffdf8] text-[#2e1065]'}`} data-id="element-257" data-mp="3nkvx6ariqtdq">
            <input type="checkbox" checked={includesInterpretation} onChange={event => setIncludesInterpretation(event.target.checked)} className="mt-0.5 h-5 w-5 shrink-0 accent-[#b78b31]" data-id="element-258" data-mp="3jlwqakm88mjn" />
            <span data-id="element-259" data-mp="2vv15w8k3otmf">
              <span className="block text-[12px] font-black uppercase leading-snug tracking-[0.06em]" data-id="element-260" data-mp="2vwlznvylc8j8">
                Sí, quiero agregar el Pack Interpretación Completa por solo $9.990
              </span>
              <span className={`mt-1 block text-[12px] leading-relaxed ${includesInterpretation ? 'text-[#e7ddf0]' : 'text-[#665873]'}`} data-id="element-261" data-mp="16f6xkl0dd6e0">
                Incluye El Lenguaje del Tarot, Diccionario de Combinaciones y sus bonos.
              </span>
            </span>
          </label>

          <div className="mt-5 grid grid-cols-2 gap-3 text-left" data-id="element-262" data-mp="1pb6rw2gtkm0r">
            <div className={includesInterpretation ? 'text-[#e7ddf0]' : 'text-[#776a7f]'} data-id="element-263" data-mp="1kdepgeijthib">
              <p className="text-[10px] font-black uppercase tracking-[0.12em]" data-id="element-264" data-mp="1fe245y7bsihu">Precio regular</p>
              <p className="mt-1 text-base font-bold line-through" data-id="element-265" data-mp="1bcgwcr9neuei">${formatPrice(offer.regular)}</p>
              <p className="mt-3 text-[10px] font-black uppercase tracking-[0.12em]" data-id="element-266" data-mp="3ywyclbwe3u0">Ahorro</p>
              <p className={`mt-1 text-sm font-black ${includesInterpretation ? 'text-[#e2bd65]' : 'text-[#4b257a]'}`} data-id="element-267" data-mp="3wkbbtra93a3">
                ${formatPrice(savings)}
              </p>
            </div>
            <div className="text-right" data-id="element-268" data-mp="2biu3q5ity75u">
              <p className={`text-[10px] font-black uppercase tracking-[0.12em] ${includesInterpretation ? 'text-[#e7ddf0]' : 'text-[#776a7f]'}`} data-id="element-269" data-mp="2flgvy7jexu3k">
                Precio final
              </p>
              <div className={`relative mt-1 inline-block overflow-hidden ${includesInterpretation ? 'price-metallic-glow' : ''}`} data-id="element-270" data-mp="2pcblplvvbbtr">
                <p className={`whitespace-nowrap text-[34px] font-black leading-none tracking-tight md:text-[42px] ${includesInterpretation ? 'bg-[linear-gradient(105deg,#b8872f,#fff0b2,#c99b3e)] bg-clip-text text-transparent' : 'text-[#b78b31]'}`} data-id="element-271" data-mp="2uamtzs6ile9v">
                  ${formatPrice(offer.final)}
                </p>
                {!prefersReducedMotion && includesInterpretation && <span aria-hidden="true" className="purchase-shine-premium" data-id="element-272" data-mp="18ylisighitlp" />}
                {!prefersReducedMotion && !includesInterpretation && <span aria-hidden="true" className="purchase-shine-gold" data-id="element-273" data-mp="1dxerzyoqnyg2" />}
              </div>
              <span className={`mt-3 inline-flex rounded-full px-2.5 py-1 text-[10px] font-black uppercase tracking-[0.08em] ${includesInterpretation ? 'bg-[#e2bd65] text-[#2e1065]' : 'bg-[#84cc16] text-white'}`} data-id="element-274" data-mp="3fsvvj31qs9zu">
                {discount}% OFF
              </span>
            </div>
          </div>

          <button onClick={goToCheckout} className={`group relative mt-5 w-full overflow-hidden rounded-full px-5 py-4 text-[13px] font-black uppercase tracking-[0.12em] transition-colors duration-200 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${includesInterpretation ? 'bg-[linear-gradient(105deg,#b8872f,#f4d98f,#c99b3e)] text-[#2e1065] shadow-[0_18px_34px_rgba(226,189,101,0.36)] hover:shadow-[0_20px_38px_rgba(226,189,101,0.5)] focus-visible:outline-[#e2bd65]' : 'bg-[#2e1065] text-white shadow-[0_18px_34px_rgba(46,16,101,0.3)] hover:bg-[#3d187f] focus-visible:outline-[#2e1065]'}`} data-id="element-275" data-mp="3kloybldnh89a">
            {!prefersReducedMotion && (includesInterpretation ? <span aria-hidden="true" className="purchase-shine-premium" data-id="element-276" data-mp="2427p8u2j5n2l" /> : <span aria-hidden="true" className="purchase-shine-gold" data-id="element-277" data-mp="1q1n1djhrd128" />)}
            <span className="relative z-10 inline-flex items-center justify-center gap-2" data-id="element-278" data-mp="1q3gdvff1yfi5">
              Quiero el Portal Completo <ArrowRightIcon size={16} strokeWidth={2.5} aria-hidden="true" data-id="element-279" data-mp="2iq0zdz8ujxds" />
            </span>
          </button>
        </motion.div>

        <a href={INDIVIDUAL_CHECKOUT} className="mt-5 block text-center text-xs font-semibold text-[#665873] underline decoration-[#b78b31] underline-offset-4 transition-colors duration-200 ease-out hover:text-[#2e1065]" data-id="element-280" data-mp="2mqkwx3xc130g">
          Prefiero continuar solo con Constelaciones Familiares
        </a>
      </div>
    </section>;
}